import styled from "styled-components"
import { FiCheck } from "react-icons/fi"

export const RadioContainer = styled.div`
  margin: 12px 0;
  cursor: pointer;
  width: 24px;
  height: 24px;
  position: relative;

  label {
    margin-left: 32px;
    display: inline-block;
    width: 220px;
  }

  &::before {
    content: "";
    border-radius: 6px;
    border: 1px solid #ccc;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 0;
  }
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`

export const Fill = styled(FiCheck)`
  background: #f8b0bb;
  color: #fff;
  width: 0;
  height: 0;
  border-radius: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.2 ease-inherit, height 0.2 ease-in;
  pointer-events: auto;
  cursor: pointer;
  z-index: 1;

  &::before {
    content: "";
    opacity: 0;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #f8b0bb;
    border-radius: 100%;
  }
`

export const SelectOption = styled.input`
  opacity: 0;
  z-index: 2;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:checked {
    & ~ ${Fill} {
      /* width: calc(100% - 8px); */
      width: 24px;
      height: 24px;
      transition: width 0.2s ease-out, height 0.2s ease-out;

      &::before {
        opacity: 1;
        transition: opacity 0.2s ease;
        border: 1px solid #f8b0bb;
      }
    }
  }
`
